export function hasUser() {
  return !!window.lego.user
}
